import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WineBarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wine_bar"}/>
}
